import { domLoader } from "@/loader.js";

window.gamesMegaTabsLoaded = false;

function activateMegaGamesTab(root, tabId) {
  if (!root || !tabId) {
    return;
  }

  root.querySelectorAll("[data-mega-tab]").forEach(function (tab) {
    const isActive = tab.dataset.megaTab === tabId;
    tab.classList.toggle("is-active", isActive);
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
  });

  root.querySelectorAll("[data-mega-panel]").forEach(function (panel) {
    panel.classList.toggle("is-active", panel.dataset.megaPanel === tabId);
  });
}

function bindMegaGames(root) {
  if (!root || root.dataset.megaGamesBound === "1") {
    return;
  }

  root.dataset.megaGamesBound = "1";

  const tabs = root.querySelectorAll("[data-mega-tab]");
  if (!tabs.length) {
    return;
  }

  const isMobile = () => window.innerWidth <= 1024;

  tabs.forEach(function (tab) {
    tab.addEventListener("mouseenter", function () {
      if (!isMobile()) {
        activateMegaGamesTab(root, tab.dataset.megaTab);
      }
    });

    tab.addEventListener("focus", function () {
      activateMegaGamesTab(root, tab.dataset.megaTab);
    });

    tab.addEventListener("click", function () {
      if (isMobile()) {
        activateMegaGamesTab(root, tab.dataset.megaTab);
      }
    });
  });

  const initial = root.querySelector("[data-mega-tab].is-active")?.dataset.megaTab
    || tabs[0]?.dataset.megaTab;

  if (initial) {
    activateMegaGamesTab(root, initial);
  }
}

domLoader(function () {
  if (window.gamesMegaTabsLoaded) {
    return;
  }
  window.gamesMegaTabsLoaded = true;

  document.querySelectorAll(".mega-games").forEach(bindMegaGames);
});
